export default __webpack_public_path__ + "static/media/prodvsdisp3.caa59727.jpg";